import { Component } from '@angular/core';

@Component({
  selector: 'app-average-pensionable-earnings-info',
  templateUrl: './average-pensionable-earnings-info.component.html',
  styleUrls: ['./average-pensionable-earnings-info.component.scss']
})
export class AveragePensionableEarningsInfoComponent {

}
